import { render, staticRenderFns } from "./Syfw.vue?vue&type=template&id=0329e46c&scoped=true&"
import script from "./Syfw.vue?vue&type=script&lang=js&"
export * from "./Syfw.vue?vue&type=script&lang=js&"
import style0 from "./Syfw.vue?vue&type=style&index=0&id=0329e46c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0329e46c",
  null
  
)

export default component.exports